

import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetITileDataByInstitutionIdAndTrialViewCode, GetITileDataByInstitutionIdAndTrialViewCodeResponse } from '@/api/dtos';
import usePost from '../api/usePost';

const getData = (response?: SWRResponse<GetITileDataByInstitutionIdAndTrialViewCodeResponse, GetITileDataByInstitutionIdAndTrialViewCodeResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetITileDataByInstitutionIdAndTrialViewCodeResponse, GetITileDataByInstitutionIdAndTrialViewCodeResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useTileData = (trialId?: number, institutionId?: string, apiLinks?: string[], configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId || !apiLinks) {
            return undefined;
        }

        return () => {
            return new GetITileDataByInstitutionIdAndTrialViewCode({ 
                trialId, 
                institutionId, 
                apiLinksUnconfigured: apiLinks
            });
        }
    }, [trialId, institutionId, apiLinks]);

    return usePost(request, { getData, getError }, configuration);
}

export default useTileData;